import { FlexCol } from '@/components/common/Flex';
import QuestionAndAnswer from '@/components/common/QuestionAndAnswer';
import { EyebrowHeader, Paragraph, Text } from '@/components/common/Typography';
import React from 'react';

const GoalOnboardingAccountTypeQuestionAndAnswer = () => {
    return (
        <FlexCol>
            <EyebrowHeader pb={8}>Questions?</EyebrowHeader>
            <Text fontWeight="semibold" mb={6}>
                Investing with Plenty
            </Text>
            <InvestingWithPlenty />
            <Text fontWeight="semibold" my={6}>
                Goals and sharing with Plenty
            </Text>
            <GoalsAndSharingWithPlenty />
        </FlexCol>
    );
};

const InvestingWithPlenty = () => {
    return (
        <QuestionAndAnswer
            canOpenMultiple
            items={[
                {
                    question: 'Do premium portfolios cost more?',
                    answer: (
                        <Paragraph>
                            All Plenty investment products are currently at the
                            same, low 0.20% rate. We do not charge additional
                            for premium portfolios and it’s another way we bring
                            affordable access to the investment products of the
                            wealthy.
                        </Paragraph>
                    ),
                },
                {
                    question:
                        'How are premium and classic portfolios different?',
                    answer: (
                        <Paragraph>
                            Premium and classic portfolios both create
                            diversified portfolios that aim to track the market.
                            Premium portfolios use direct indexing, an advanced
                            strategy that seeks to reduce taxes through tax-loss
                            harvesting. Direct indexing uses individual stocks,
                            instead of ETFs (aka portfolios) to increase the
                            opportunities for tax loss harvesting. Classic
                            portfolios use ETFs and do not have tax loss
                            harvesting.
                        </Paragraph>
                    ),
                },
                {
                    question:
                        'Can I access premium portfolios in individual or retirement accounts?',
                    answer: (
                        <Paragraph>
                            Premium portfolios are only available in joint
                            accounts today. Premium portfolios use advanced tax
                            loss harvesting; we only offer these in joint
                            accounts to reduce the possibility of wash sales for
                            married couples. If this investment type is
                            important to you in other accounts, we’d love to
                            hear from you at members@withplenty.com.
                        </Paragraph>
                    ),
                },
                {
                    question: 'Can I use classic portfolios in joint accounts?',
                    answer: (
                        <Paragraph>
                            Classic portfolios are not currently available in
                            joint accounts. If this is important to you, we’d
                            love to hear from you at members@withplenty.com.
                        </Paragraph>
                    ),
                },
                {
                    question: 'What expense ratios do portfolios have?',
                    answer: (
                        <Paragraph>
                            Premium and classic portfolios have a total expense
                            ratio of 0.07% - 0.13%, depending on your risk
                            score. We use a low cost ETF for domestic stock and
                            bond exposure, and one of the lowest cost ETFs for
                            international stocks. International stock exposure
                            is typically more expensive because they have more
                            transaction fees, since companies are based on other
                            stock exchanges.
                        </Paragraph>
                    ),
                },
            ]}
        />
    );
};

const GoalsAndSharingWithPlenty = () => {
    return (
        <QuestionAndAnswer
            canOpenMultiple
            items={[
                {
                    question: 'Can I change my goal type later?',
                    answer: (
                        <Paragraph>
                            You can always create and close goals. If you’d like
                            to change your goal type later, you can do so by
                            creating a new goal. To close your existing goal,
                            you’ll need to withdraw funds to reduce the balance
                            to $0 before closing.
                        </Paragraph>
                    ),
                },
                {
                    question: 'How do split goals work?',
                    answer: (
                        <Paragraph>
                            If you and your partner use a split goal, you will
                            each deposit into your own individual investment
                            account. We create a virtual layer to show what your
                            goals savings are together. You will only be able to
                            withdraw whatever you’ve deposited.
                        </Paragraph>
                    ),
                },
                {
                    question: 'How are split goals and joint goals different?',
                    answer: (
                        <Paragraph>
                            Joint goals are goals held in a joint brokerage
                            account that you own equally with your partner.
                            Either individual may deposit or withdraw from this
                            shared balance. Split goals are held in individual
                            brokerage accounts under each of your names. You may
                            only withdraw as much as you have individually
                            deposited.
                        </Paragraph>
                    ),
                },
                {
                    question: 'Can my partner see a private goal?',
                    answer: (
                        <Paragraph>
                            Your partner will not be able to see the existence
                            of the private goal. You will only be able to see
                            your private goal in the “What’s mine” view.
                        </Paragraph>
                    ),
                },
                {
                    question:
                        'Am I opening a new brokerage account with each goal?',
                    answer: (
                        <Paragraph>
                            Each goal creates a new bucket within your existing
                            account, that Plenty helps manage and track.
                        </Paragraph>
                    ),
                },
            ]}
        />
    );
};

export default GoalOnboardingAccountTypeQuestionAndAnswer;
